import { useState } from "react";
import { faqs } from "../../../mocks/anime";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[900px] px-4 md:px-6">
        <div className="mb-8 text-center md:mb-10">
          <p className="mb-2 text-xs font-bold tracking-widest text-primary-600">常见问题</p>
          <h2 className="font-display text-2xl text-foreground-950 md:text-4xl">
            关于女神动漫，你可能想知道的
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => {
            const active = openIndex === index;
            return (
              <div
                key={faq.q}
                className="overflow-hidden rounded-lg bg-background-50"
              >
                <button
                  onClick={() => setOpenIndex(active ? -1 : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={active}
                >
                  <span className="font-display text-sm text-foreground-950 md:text-base">
                    {faq.q}
                  </span>
                  <i
                    className={`ri-add-line shrink-0 text-xl text-primary-600 transition-transform duration-300 ${
                      active ? "rotate-45" : ""
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    active ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}